import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const VideoElementFields = {
  group: ELEMENT_GROUPS.MEDIA,
  label: 'Video',
  icon: 'VideoCameraIcon',
  description: 'Adds a video to the screen',
  properties: [
    'layout',
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'datasourceFieldMarkup',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Video Url',
      name: 'url',
      editor: 'textbox',
      description:
        'The static video url that will be used if not bound to a data source',
      default: '',
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_EMPTY',
          value: []
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Border Width',
      name: 'borderWidth',
      editor: 'number',
      description: 'The border width of a list item',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius',
      name: 'borderRadius',
      editor: 'number',
      description: 'The border radius of the video',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Color',
      name: 'borderColor',
      editor: 'color',
      description: 'The border color of the video',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Video Width',
      name: 'width',
      editor: 'number',
      description: 'The width of the video',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Video Height',
      name: 'height',
      editor: 'number',
      description: 'The height of the video',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    'alignment',
    'margin',
    'padding'
  ]
};

export default VideoElementFields;
